import React from 'react';
import { Link } from 'react-router-dom';
import { WalletMultiButton } from '@solana/wallet-adapter-react-ui';

const Header: React.FC = () => {
  return (
    <div className="header">
      <div className="header-inner">
        <Link to="/create" style={{ textDecoration: 'none', color: 'inherit' }}>
          <h1>
            <img 
              src="/pngbloot.png" 
              alt="Bloot Logo" 
              style={{ 
                height: '96px', 
                width: 'auto', 
                marginRight: '8px',
                verticalAlign: 'middle'
              }} 
            />
            bloot.fun
          </h1>
        </Link>
        <WalletMultiButton />
      </div>
    </div>
  );
};

export default Header;
